import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Toggle } from '@ahmdigital/ui';
import { useCallback } from 'react';
import moment from 'moment';

import { HelpLink, StyledIcon, Wrapper } from './styles';
import {
  PREMIUM_REVIEW_TOGGLE_STYLE,
  PremiumReviewToggleStyleType,
  USE_FUTURE_EFFECTIVE_DATE,
} from '../../ahm-constants/ui';
import device from '../../utils/device';
import PREMIUM_CHANGE from '../../features/premium-change/constants';
import PriceActions from '../../actions/price';
import selectIsPremiumChangeEnabled from '../../selectors/select-is-premium-change-enabled';
import styles from './styles.module.sass';

const formattedEffectiveDate = moment(PREMIUM_CHANGE.FUTURE_EFFECTIVE_DATE).format('MMMM D');

type PremiumChangePromptProps = {
  actions: { price: { changeEffectiveDate: (value: boolean) => void } };
  isAlternativePage?: boolean;
  isPremiumChangeEnabled?: boolean;
  toggleModal: () => void;
  useFutureEffectiveDate: boolean;
  type?: PremiumReviewToggleStyleType;
};

const PremiumChangePrompt = ({
  actions,
  isAlternativePage = false,
  isPremiumChangeEnabled = false,
  toggleModal,
  type,
  useFutureEffectiveDate,
}: PremiumChangePromptProps) => {
  const onChange = useCallback(() => {
    actions.price.changeEffectiveDate(!useFutureEffectiveDate);
  }, [actions.price, useFutureEffectiveDate]);

  if (!isPremiumChangeEnabled) {
    return null;
  }

  const isReadOnly = type === PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY;

  return (
    <Wrapper isAlternativePage={isAlternativePage} type={type}>
      {isReadOnly ? (
        <> {useFutureEffectiveDate ? USE_FUTURE_EFFECTIVE_DATE.AFTER : USE_FUTURE_EFFECTIVE_DATE.BEFORE} </>
      ) : (
        <div className={styles.toggleContainer}>
          <Toggle
            label={`Price ${useFutureEffectiveDate ? `after ${formattedEffectiveDate}` : `before ${formattedEffectiveDate}`}`}
            isChecked={useFutureEffectiveDate}
            isCompact={!device.isMobile()}
            isDisabled={false}
            isWhite={false}
            isLabelAfterSwitch
            onChange={onChange}
            screenReaderLabelSuffix="premiumChangeToggle"
          />
        </div>
      )}
      <HelpLink onClick={toggleModal} aria-label="More about Premium Review">
        <StyledIcon fill="currentColor" name="question-circle" type={type} />
      </HelpLink>
    </Wrapper>
  );
};

type StateProps = {
  isPremiumChangeEnabled: boolean;
  useFutureEffectiveDate: boolean;
};

const mapStateToProps = (state: any): StateProps => ({
  isPremiumChangeEnabled: selectIsPremiumChangeEnabled(state),
  useFutureEffectiveDate: state.price.useFutureEffectiveDate,
});

type DispatchProps = {
  actions: { price: { changeEffectiveDate: (value: boolean) => void } };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  actions: {
    price: bindActionCreators(PriceActions, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PremiumChangePrompt);

export { PremiumChangePrompt as PremiumChangePromptForTest, mapStateToProps, mapDispatchToProps };
